import React from 'react';
import { Paper, Radio, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PaymentMethodOption = ({
	value,
	selected,
	onChange,
	disabled = false,
	title,
	subtitle,
	RightIcon,
}) => {
	const theme = useTheme();

	return (
		<Paper
			variant="outlined"
			onClick={() => !disabled && onChange(value)}
			sx={{
				height: '52px',
				p: '5px 14px',
				borderRadius: 2,
				cursor: disabled ? 'not-allowed' : 'pointer',
				opacity: disabled ? 0.5 : 1,
				borderColor: selected ? 'primary.main' : theme.palette.gray.gray5,
				bgcolor: selected ? 'primary.50' : 'background.paper',
				'&:hover': !disabled && { borderColor: 'primary.main', bgcolor: 'action.hover' },
				transition: 'background-color .15s, border-color .15s',
			}}
		>
			<Stack direction="row" alignItems="center" spacing={2}>
				<Radio checked={selected} onChange={() => onChange(value)} disabled={disabled} value={value} />
				<Stack flex={1} minWidth={0}>
					<Typography fontWeight={700}>{title}</Typography>
					{!!subtitle && (
						<Typography variant="body2" color="text.secondary">
							{subtitle}
						</Typography>
					)}
				</Stack>
				{RightIcon ? (
					<RightIcon fontSize="medium" sx={{ color: selected ? 'primary.main' : theme.palette.gray.gray4 }} />
				) : null}
			</Stack>
		</Paper>
	);
};

export default PaymentMethodOption;
